import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { IssueCardStackRoutes, IssueCardStackScreenProps } from './type';
import { IssueCardWebTwoScreen } from './IssueCardWebTwo.screen';
import { IssueCardNativeTwoScreen } from './IssueCardNativeTwo.screen';

export interface IssueCardProps {}
export const IssueCardPlaced: React.FC<IssueCardStackScreenProps<IssueCardStackRoutes.Placed>> = ({ navigation, route }) => {
  const { onLayout, data, account, tab, returnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <IssueCardNativeTwoScreen onClose={onGoBack} data={data} account={account} tab={tab} returnData={returnData} refresh={refresh} />
    );
  }

  return (
    <IssueCardWebTwoScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      account={account}
      tab={tab}
      returnData={returnData}
      refresh={refresh}
    />
  );
};
